import { USER_ROLES } from '@pwc/pwc-deals-web-common';

export const ENTITY_TYPES = {
  ANALYSIS: 'ANALYSIS',
  KFA: 'KFA',
};

export const CUSTOM_COLOR_CONVERSION_KEY = 'contentColourConversion';

export const FAVOURITE = 'Favourites';

export const CUSTOM_COLOUR_MODAL_TEXT = `This project uses a custom colour theme that can only be viewed in
light mode. When viewing other projects, you can switch to dark mode
in the header.`;

export const USER_TYPE_CLASSES = {
  [USER_ROLES.PWC_USER]: 'pwc-user',
  [USER_ROLES.CLIENT]: 'client-user',
};
export const US_FAVOURITE = 'Favorites';

export const EMPTY_FAVOURITE_HEADING = 'youHaveNoFavouritedProjects';

export const US_EMPTY_FAVOURITE_HEADING = 'youHaveNoFavoritedProjects';
